import { Injectable } from '@angular/core';

import { CatalogStorageServiceBase } from '../baseBtl/catalog/catalog-storage.service';

@Injectable({
    providedIn: 'root',
})
export class CatalogStorageService extends CatalogStorageServiceBase {
    public KEY: { [index: string]: string } = {
        PRODUCTS: 'products',
        FILTERS: 'filters',
        PRICE_FILTER: 'price_filter',
        PRICES_BY_PLAN: 'prices_by_plan',
        SORT: 'sort',
        COMPARATOR: 'comparator',
        WITHOUT_TAX: 'without_tax',
    };
    protected prefix: string = 'catalog_';

    protected sessionStorageKeys: string[] = Object.values(this.KEY);
}
